const styles = theme => ({
  topMarginForSlides: {
    marginTop: '11px'
  },
  dateCard: {
    top: '-11px',
    left: '35px',
    backgroundColor: '#D91119',
    borderRadius: '20px',
    lineHeight: 'normal',
    padding: '11px 16px'
  },
  dateCardSecond: {
    backgroundColor: '#009A44'
  },
  sliderTitle: {
    fontSize: '17px',
    color: '#191C30 !important',
    fontWeight: 'normal'
  }

});

export default styles;
